import { useState, useEffect } from 'react';

/**
 * 客服端全局网络状态 Toast
 * 监听浏览器 online/offline 事件，断网时显示「网络不可用，请确认连接后重试」
 * 挂载在 CsAuthGuard 中，对所有客服页面生效
 */
export default function CsNetworkToast() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOffline = () => setIsOffline(true);
    const handleOnline = () => setIsOffline(false);

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'rgba(0, 0, 0, 0.75)',
        color: '#fff',
        padding: '12px 24px',
        borderRadius: '8px',
        fontSize: '14px',
        zIndex: 10000,
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        maxWidth: '80vw',
        textAlign: 'center',
      }}
    >
      网络不可用，请确认连接后重试
    </div>
  );
}
